import { COLORS } from 'helpers/globals'

const feathering = {
  position: 'absolute',
  width: '100%',
  height: '1.5rem',
  top: '-1.5rem',
  content: '""',
  background: 'linear-gradient(to top, rgba(200,200,200, 1), rgba(255,255,255, 0))'
}

export default {
  modelSelector: {
    flex: '0 0 65%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    zIndex: 2,
    background: 'white'
  },
  bottomWrapper: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    '&:before': feathering
  },
  bottomButton: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: '0 0 33.33%',
    background: 'white',
    color: COLORS.secondary,
    textAlign: 'center',
    padding: '1.2rem 0',
    '& > p': {
      marginBottom: 0
    }
  },
  selected: {
    background: '#eeeeee',
    color: COLORS.primary
  },
  bottomIcon: {
    margin: '0 auto .3rem auto',
    fontSize: '2rem'
  },
  switchWrapper: {
    display: 'flex',
    background: '#eeeeee',
    position: 'relative',
    '&:before': feathering
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    margin: '1.5rem auto',
    fontSize: '2rem',
    fontWeight: '400',
    '& span': {
      paddingRight: '1rem'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomBar/ModelSelector/style.js